import { EmailFromType } from '@enums/email-from-type.enum';
import { EmailAttachment, EmailAttachmentJson } from '@models/email-attachment';
import { EmailFrom, EmailFromJson } from '@models/email-from';

export interface EmailTemplateJson {
  body: string;
  cc: string[];
  cci: string[];
  froms: EmailFromJson[];
  subject: string;
  to: string[];
  reply_to: string | null;
  attachments: Partial<EmailAttachmentJson>[];
}

export class EmailTemplate {
  constructor(
    public body: string,
    public cc: string[],
    public cci: string[],
    public froms: EmailFrom[],
    public subject: string,
    public to: string[],
    public replyTo: string | null,
    public attachments: EmailAttachment[] = []
  ) {}

  static fromJson(json: Partial<EmailTemplateJson>): EmailTemplate {
    return new EmailTemplate(
      json.body,
      json.cc,
      json.cci,
      (json.froms ?? []).map((j: EmailFromJson) => EmailFrom.fromJson(j)),
      json.subject,
      json.to,
      json.reply_to,
      (json.attachments ?? []).map((j: EmailAttachmentJson) => EmailAttachment.fromJson(j))
    );
  }

  /**
   * Retourne l'email à utiliser de préférence suivant l'ordre suivant :
   * - L'email associé à la fonction de l'intervenant configurer sur le partner
   * - L'email de l'utilisateur
   * - Le premier email de la liste
   * @returns {string | null}
   */
  getPreferredPlainFromEmail(): string | null {
    const preferredFrom = this.findFromType(EmailFromType.emailCompanyContributor);
    if (preferredFrom) {
      return preferredFrom.email;
    }
    const userFrom = this.findFromType(EmailFromType.emailUser);
    if (userFrom) {
      return userFrom.email;
    }
    return this.froms[0]?.email ?? null;
  }

  private findFromType(type: EmailFromType): EmailFrom | null {
    return (this.froms ?? []).find((from: EmailFrom) => from.type === type) ?? null;
  }
}
